export const environment = {
  production: false,
  ccitySimulateEnabled: true,
  API_BASE_URL: 'https://qaapi.pactrak.com',
  b2cRedirectURL : 'https://qa.pactrak.com/',
  MOCK_API_URL: 'https://qapactrak.azurewebsites.net',
  B2CName: 'B2C_1_qa-pactrak',
  clientId: '2967a81a-b153-4df4-9597-b96fc0a88335',
  B2CApiName: 'qa-pactrak-api',
  azureCDNAccountsData: 'https://pactrakcdn.z13.web.core.windows.net/account-summary-help.json',
  azureCDNAdvancedSearchHelp: 'https://pactrakcdn.z13.web.core.windows.net/advanced-search-help.json',
  azureCDNUserManagementHelp: 'https://pactrakcdn.z13.web.core.windows.net/user-management-summary-help.json',
  azureCDNShortcutKeysCatalog: 'https://pactrakcdn.z13.web.core.windows.net/shortcut-keys.catalog.json',
  azureCDNRolesAndPermissionHelp: 'https://pactrakcdn.z13.web.core.windows.net/roles-and-permissions-summary-help.json',
  // Telemetry configuration
  telemetry: {
    enabled: true,
    fallbackToConsole: true,
  },
  // Roles & Permissions Enforcement configuration
  rolesPermissionsEnforcement: {
    enabled: true,
  },
  b2authority: 'https://pactrakuser.b2clogin.com/pactrakuser.onmicrosoft.com/',
  authorityDomain: 'pactrakuser.b2clogin.com',
  protectedResources: 'https://pactrakuser.onmicrosoft.com/'
};
